// extracted by mini-css-extract-plugin
module.exports = {"relativePosition":"Dialog_relativePosition__1v9H0","contentFullHeight":"Dialog_contentFullHeight__38YfK","closeButtonWrapper":"Dialog_closeButtonWrapper__20AGF"};